// Favori ekranlar widget'ı — Blazor FavoritesWidget.
import { useTranslation } from 'react-i18next';
import { NavIcon } from '@/features/shell/navMenu/NavIcon';
import { useMenu } from '@/features/shell/navMenu/useMenu';
import { useOpenScreen } from '@/features/shell/tabs/useOpenScreen';
import { EmptyState } from '@/shared/ui/EmptyState';

export function FavoritesWidget() {
  const { t } = useTranslation();
  const { favorites } = useMenu();
  const openScreen = useOpenScreen();
  if (favorites.length === 0) return <EmptyState title={t('home.noFavorites')} />;
  return (
    <ul className="h-full space-y-1 overflow-auto">
      {favorites.map((f) => (
        <li key={f.screenId}>
          <button
            type="button"
            data-favorite-card
            onClick={() => openScreen(f)}
            className="hover:bg-bg-hover flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm"
          >
            <NavIcon node={f} className="h-4 w-4 shrink-0" />
            <span className="truncate">{f.caption}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
